function hasEmptyGuestsCount(guestsCount) {
    return !guestsCount;
}

// eslint-disable-next-line no-unused-vars
function hasEmptyGuests(adultsCount, childrenCount, petIncluded) {
    return hasEmptyGuestsCount(adultsCount);
}

function hasEmptyGuestsValues({adultsCount, childrenCount, petIncluded}) {
    return hasEmptyGuests(adultsCount, childrenCount, petIncluded);
}

function hasFilledGuestsCount(guestsCount) {
    return !hasEmptyGuestsCount(guestsCount);
}

/* istanbul ignore next */
// eslint-disable-next-line no-unused-vars
function hasFilledGuests(adultsCount, childrenCount, petIncluded) {
    return hasFilledGuestsCount(adultsCount);
}

/* istanbul ignore next */
function hasFilledGuestsValues({adultsCount, childrenCount, petIncluded}) {
    return hasFilledGuests(adultsCount, childrenCount, petIncluded);
}

function hasValidGuestsCount(guestsCount) {
    return hasFilledGuestsCount(guestsCount);
}

// eslint-disable-next-line no-unused-vars
function hasValidGuests(adultsCount, childrenCount, petIncluded) {
    return hasValidGuestsCount(adultsCount);
}

function hasValidGuestsValues({adultsCount, childrenCount, petIncluded}) {
    return hasValidGuests(adultsCount, childrenCount, petIncluded);
}

function showGuestsInputFieldError(media, guests) {
    const {
        settings: {
            isMobile
        }
    } = media;

    const {
        options: {
            allowErrorHighlighting
        },
        latestValues
    } = guests;

    return !isMobile && allowErrorHighlighting && !hasValidGuestsValues(latestValues);
}

export {
    hasEmptyGuests,
    hasEmptyGuestsCount,
    hasEmptyGuestsValues,
    hasFilledGuests,
    hasFilledGuestsCount,
    hasFilledGuestsValues,
    hasValidGuests,
    hasValidGuestsCount,
    hasValidGuestsValues,
    showGuestsInputFieldError
};
